import { render, staticRenderFns } from "./StackSplit.vue?vue&type=template&id=0d17e881&"
import script from "./StackSplit.vue?vue&type=script&lang=ts&"
export * from "./StackSplit.vue?vue&type=script&lang=ts&"
import style0 from "./StackSplit.vue?vue&type=style&index=0&id=0d17e881&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports